/* eslint-disable react-hooks/rules-of-hooks */
// @ts-nocheck
import { useNotificationSummary } from "@dev-togetherprice/api.notification";
import BellIcon from "@dev-togetherprice/icons.bell";
import GiftIcon from "@dev-togetherprice/icons.gift";
import LogoExpanded from "@dev-togetherprice/icons.logo-expanded";
import { useConfigurations } from "@dev-togetherprice/api.user";
import useRegisteredTranslation from "@dev-togetherprice/hooks.use-register-translation";
import { useUserRiskManagement } from "@dev-togetherprice/api.settings";
import SearchField, { defaultSearchProps, } from "@dev-togetherprice/components.search-field";
import IconButton from "@dev-togetherprice/components.icon-button";
import { AppBar, Button, Grid, Hidden, makeStyles, Toolbar, } from "@material-ui/core";
import { mergeClasses } from "@material-ui/styles";
import React from "react";
import { ChevronLeft } from "@material-ui/icons";
import clsx from "clsx";
import { Skeleton } from "@material-ui/lab";
import en from "./i18n/en.json";
import it from "./i18n/it.json";
import es from "./i18n/es.json";
import pt from "./i18n/pt.json";
const TRANSLATIONS = { en, es, it, pt };
export const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(5, 4),
    },
    search: {
        maxWidth: "465px",
        width: "100%",
    },
    wrapper: {
        display: "flex",
    },
    iconWrapper: {
        display: "flex",
        flexDirection: "row",
        marginRight: theme.spacing(4),
        justifyContent: "flex-end",
    },
    iconInner: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        maxWidth: "400px",
        width: "100%",
    },
    searchWrapper: {
        display: "flex",
        alignItems: "center",
    },
    icon: {
        height: "40px",
        width: "40px",
        marginLeft: theme.spacing(6),
        border: `1px solid ${theme.palette.common.white}`,
    },
    leftside: {
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        justifyContent: "space-between",
        paddingRight: theme.spacing(6),
        paddingLeft: theme.spacing(3),
        width: "325px",
        transition: ".4s",
    },
    rightside: {
        flex: "1 1",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    },
    sidebarController: {
        transform: ({ showSidebar }) => {
            if (showSidebar)
                return "rotate(0) translateX(-2px)";
            return "rotate(180deg) translateX(+2px)";
        },
    },
    logoWrapper: { display: "flex", flexDirection: "row" },
    logo: {
        cursor: "pointer",
        width: "auto",
        height: "32px",
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    iconWithNotReadNotifications: {
        border: `1px solid ${theme.palette.secondary.main}`,
    },
    button: {
        height: "40px",
        borderRadius: theme.spacing(3),
        paddingLeft: theme.spacing(4),
        boxShadow: "none",
        paddingRight: theme.spacing(4),
        margin: theme.spacing(0, 2),
    },
    bgRed: {
        backgroundColor: theme.palette.error.main,
    },
}), { name: "DesktopHeader" });
export const DesktopHeaderSkeleton = ({ classes: newClasses, }) => {
    const baseClasses = useStyles({ showSidebar: false });
    const classes = mergeClasses({
        newClasses: newClasses,
        baseClasses,
        Component: DesktopHeaderSkeleton,
    });
    return (React.createElement(Hidden, { smDown: true },
        React.createElement(AppBar, { position: "static", color: "transparent", elevation: 0 },
            React.createElement(Toolbar, { className: classes.root },
                React.createElement(Grid, { item: true, xs: 12, className: classes.wrapper },
                    React.createElement(Grid, { item: true, xs: 3, className: classes.leftside },
                        React.createElement(Grid, { className: classes.logoWrapper },
                            React.createElement(Skeleton, { variant: "rect" }),
                            React.createElement(Skeleton, { className: classes.icon, width: "100px" })),
                        React.createElement(Skeleton, { className: classes.icon, variant: "circle" })),
                    React.createElement(Grid, { item: true, xs: 6, className: classes.searchWrapper },
                        React.createElement(Grid, { className: classes.search },
                            React.createElement(Skeleton, { height: "50px" }))),
                    React.createElement(Grid, { item: true, xs: 3, className: classes.iconWrapper },
                        React.createElement(Grid, { className: classes.iconInner },
                            React.createElement(Skeleton, { className: classes.groupButton, width: "130px", height: "50px" }),
                            React.createElement(Skeleton, { className: classes.icon, variant: "circle" }),
                            React.createElement(Skeleton, { className: classes.icon, variant: "circle" }))))))));
};
const DesktopHeader = ({ classes: newClasses = {}, searchProps, toggleSidebar, isPublic, onCannotCreatePost, showSidebar, navigateToUrl, }) => {
    var _a;
    const canCreatePost = !isPublic && ((_a = useUserRiskManagement().createNewGroup) !== null && _a !== void 0 ? _a : true);
    const notifications = !isPublic && useNotificationSummary();
    const { data } = useConfigurations();
    const isReferralEnabled = !!JSON.parse(data['frontEnd.referral.enabled']);
    const { t } = useRegisteredTranslation("DesktopHeader", TRANSLATIONS);
    const baseClasses = useStyles({ showSidebar });
    const classes = mergeClasses({
        baseClasses,
        newClasses,
        Component: DesktopHeader,
    });
    return (React.createElement(Hidden, { smDown: true },
        React.createElement(AppBar, { position: "static", color: "transparent", elevation: 0 },
            React.createElement(Toolbar, { className: classes.root },
                React.createElement(Grid, { item: true, xs: 12, className: classes.wrapper },
                    React.createElement(Grid, { item: true, className: classes.leftside },
                        React.createElement(IconButton, { variant: "filled", color: "primary", size: "small", style: {
                                width: "30px",
                                height: "30px",
                                paddingLeft: "5px",
                            }, onClick: toggleSidebar },
                            React.createElement(ChevronLeft, { className: classes.sidebarController, fontSize: "default" })),
                        React.createElement(LogoExpanded, { className: classes.logo, onClick: () => navigateToUrl("/") })),
                    React.createElement(Grid, { item: true, className: classes.rightside },
                        React.createElement(Grid, { item: true, xs: 6, className: classes.searchWrapper },
                            React.createElement(Grid, { className: classes.search },
                                React.createElement(SearchField, Object.assign({}, defaultSearchProps, searchProps, { desktop: true })))),
                        React.createElement(Grid, { item: true, xs: 6, className: classes.iconWrapper }, !isPublic ? (React.createElement("div", { className: classes.iconInner },
                            React.createElement(Button, { variant: "contained", color: "secondary", size: "small", className: clsx(classes.button, classes.bgRed), onClick: canCreatePost
                                    ? () => navigateToUrl("/create")
                                    : onCannotCreatePost }, t("create")),
                            isReferralEnabled && (React.createElement(IconButton, { variant: "filled", color: "primary", "aria-label": "gift", size: "small", className: classes.icon, onClick: () => navigateToUrl("/referral") },
                                React.createElement(GiftIcon, { fontSize: "small" }))),
                            React.createElement(IconButton, { variant: "filled", color: "primary", "aria-label": "notifications", size: "small", className: clsx(classes.icon, {
                                    [classes.iconWithNotReadNotifications]: !!(notifications === null || notifications === void 0 ? void 0 : notifications.notRead),
                                }), onClick: () => navigateToUrl("/feed/requests") },
                                React.createElement(BellIcon, { fontSize: "small" })))) : (React.createElement("div", { className: classes.iconInner },
                            React.createElement(Button, { variant: "contained", color: "primary", size: "small", className: classes.button, onClick: () => navigateToUrl("/login") }, t("login")),
                            React.createElement(Button, { variant: "contained", color: "secondary", size: "small", className: classes.button, onClick: () => navigateToUrl("/sign-up") }, t("signup")))))))))));
};
export default DesktopHeader;
